import { h as head, e as escape_html, b as attr, p as pop, a as push } from "../../../chunks/index2.js";
import "@sveltejs/kit/internal";
import "../../../chunks/exports.js";
import "../../../chunks/utils.js";
import "../../../chunks/state.svelte.js";
import { g as getToastState } from "../../../chunks/Toast.svelte.js";
function _page($$payload, $$props) {
  push();
  const { form } = $$props;
  let name = form?.data?.name;
  let email = form?.data?.email;
  let password = "";
  let confirmPassword = "";
  getToastState();
  head($$payload, ($$payload2) => {
    $$payload2.title = `<title>ADMIN INITIAL REGISTRATION</title>`;
    $$payload2.out.push(`<link rel="preload" href="/banner-bg.jpg" as="image"/>`);
  });
  $$payload.out.push(`<div class="loginbg flex min-h-screen items-center justify-center bg-gray-100 lg:bg-contain svelte-upjbla"><div class="w-1/3 min-w-72 rounded-md bg-white p-8 shadow-lg"><h2 class="text-center text-2xl font-bold">ADMIN INITIAL REGISTRATION</h2> `);
  if (form?.errors) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<span class="text-sm text-red-600">${escape_html(form?.errors)}</span>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> <form class="mt-4" method="POST"><div class="mb-4"><label for="email" class="block text-sm font-semibold">Full Name</label> <input type="text" id="name" name="name" class="w-full rounded-md border p-2"${attr("value", name)} required/></div> <div class="mb-4"><label for="email" class="block text-sm font-semibold">Email</label> <input type="email" id="email" name="email" class="w-full rounded-md border p-2"${attr("value", email)} required/></div> <div class="mb-4"><label for="password" class="block text-sm font-semibold">Password</label> <input type="password" id="password" name="password" class="w-full rounded-md border p-2"${attr("value", password)} required/></div> <div class="mb-4"><label for="confirmPassword" class="block text-sm font-semibold">Confirm Password</label> <input type="password" id="confirmPassword" class="w-full rounded-md border p-2" name="confirmPassword"${attr("value", confirmPassword)} required/> `);
  {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></div> <button type="submit" class="hover:bg-primary w-full rounded-md border p-2 transition-colors hover:text-white disabled:opacity-50">Register</button> <span class="hover:text-secondary text-sm"><a href="/login">Back to login</a></span></form></div></div>`);
  pop();
}
export {
  _page as default
};
